import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import { api_url } from '../config/config';
import DeletePrompt from "../Components/common/DeletePrompt";

function ConcernManagement() {
    const [concerns, setConcerns] = useState([]);
    const [formData, setFormData] = useState({ name: '', image_file: null });
    const [editingConcernId, setEditingConcernId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
      const fileInputRef = useRef(null);
    const [error, setError] = useState(null);  // For error messages
    const [successMessage, setSuccessMessage] = useState(null);  // For success messages
    const [isPopupOpen, setIsPopupOpen] = useState(false); // State to control popup visibility

    // Fetch concerns with pagination
    useEffect(() => {
        fetchConcerns();
    }, [currentPage]);

    const fetchConcerns = () => {
        axios
            .get(`${api_url}/concerns?page=${currentPage}&limit=50`,

                {
      
                    headers: { "Content-Type": "multipart/form-data ", 
                      
                      'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
                  
                   },
                  
                    
                  }
            )


            
            .then(response => {
                if (response.data.results) {
                    setConcerns(response.data.results);
                    setTotalPages(response.data.totalPages);
                }
            })
            .catch(err => {
                setError(`Error fetching concerns: ${err.message}`);
                console.error("Error fetching concerns:", err);
            });
    };

 
    // Handle input change
    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'image_file') {
            setFormData({ ...formData, [name]: files[0] });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // Create concern
    const handleCreateConcern = () => {
        const isDuplicate = concerns.some(
            (concern) => concern.name.toLowerCase() === formData.name.toLowerCase()
        );
    
        if (isDuplicate) {
            setError('Concern name already exists!');
            return;
        }
    
        const formDataToSend = new FormData();
        formDataToSend.append('concern_name', formData.name);
        if (formData.image_file) {
           
            formDataToSend.append('file', formData.image_file);
        }
    
        axios
            .post(`${api_url}/concern`, formDataToSend, {
                headers: { "Content-Type": "multipart/form-data ", 
          
                    'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
                
                 },
            })
            .then(response => {
                if (response.data.status === 'success') {
                    setConcerns([...concerns, response.data.concern]);
                    setFormData({ name: '', image_file: null });
                    if (fileInputRef.current) {
                        fileInputRef.current.value = ""; // Clear file input field
                    }
                    fetchConcerns();
                    setSuccessMessage('Concern created successfully!');
          
                }
            })
            .catch(err => {
                setError(`Error creating concern: ${err.message}`);
                console.error("Error creating concern:", err);
            });
    };

    // State for delete modal
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [concernToDelete, setConcernToDelete] = useState(null);

    const handleDeleteConcern = (concernId) => {
        setConcernToDelete(concernId);
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = () => {
        if (!concernToDelete) return;
        axios
            .delete(`${api_url}/concern/${concernToDelete}`,
                {
                    headers: { "Content-Type": "multipart/form-data ", 
                        'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
                    },
                }
            )
            .then(response => {
                if (response.data.status === 'success') {
                    setConcerns(concerns.filter(concern => concern.concern_id !== concernToDelete));
                    setSuccessMessage('Concern deleted successfully!');
                    setShowDeleteModal(false);
                    setConcernToDelete(null);
               
                } else {
                    setError(`Failed to delete concern: ${response.data.message}`);
                    console.error(`Failed to delete concern: ${response.data.message}`);
                }
            })
            .catch(err => {
                setError(`Error deleting concern: ${err.message}`);
                console.error("Error deleting concern:", err);
            });
    };

    // Edit concern
    const handleEditConcern = (concern) => {
        setEditingConcernId(concern.concern_id);
        setFormData({ name: concern.name, image_file: null });
        if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Clear file input field
        }
    };

    // Update concern
    const handleUpdateConcern = () => {
        const formDataToSend = new FormData();
        formDataToSend.append('concern_name', formData.name);
        formDataToSend.append('concern_id', editingConcernId);
    
        if (formData.image_file) {
            formDataToSend.append('file', formData.image_file);
        }
    
        axios
            .patch(`${api_url}/concern`, formDataToSend, {
                headers: { "Content-Type": "multipart/form-data ", 
          
                    'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
                
                 },
            })
            .then(response => {
                if (response.data.status === 'success') {
                    setConcerns(
                        concerns.map(concern =>
                            concern.concern_id === editingConcernId
                                ? { ...concern, ...response.data.updatedConcern }
                                : concern
                        )
                    );
                    setFormData({ name: '', image_file: null });
                    if (fileInputRef.current) {
                        fileInputRef.current.value = ""; // Clear file input field
                    }
                    setEditingConcernId(null);
                    setSuccessMessage('Concern updated successfully!');
                    setIsPopupOpen(true); // Open the popup on success
                }
            })
            .catch(err => {
                setError(`Error updating concern: ${err.message}`);
                console.error("Error updating concern:", err);
            });
    };

    // Handle page change
    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    // Reset error and success messages after a delay
    useEffect(() => {
        if (error || successMessage) {
            const timer = setTimeout(() => {
                setError(null);
                setSuccessMessage(null);
                setIsPopupOpen(false); // Close the popup after timeout
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [error, successMessage]);

    return (
        <div className="p-10">
            <h2 className="text-2xl font-semibold mb-5">Concern Management</h2>

            {error && <div className="bg-red-500 text-white p-2 mb-4 rounded">{error}</div>}
            {successMessage && <div className="bg-green-500 text-white p-2 mb-4 rounded">{successMessage}</div>}

            <div className="mb-5">
                <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Enter concern name"
                    className="border border-gray-300 rounded-lg p-2 mr-2"
                />
                <input
                    type="file"
                    name="image_file"
                    ref={fileInputRef} 
                    onChange={handleInputChange}
                    className="border border-gray-300 rounded-lg p-2 mr-2"
                />
                {editingConcernId ? (
                    <button
                        onClick={handleUpdateConcern}
                        className="bg-[#3C1F1F]  text-white px-4 py-2 rounded-lg"
                    >
                        Update Concern
                    </button>
                ) : (
                    <button
                        onClick={handleCreateConcern}
                        className="bg-[#3C1F1F]  text-white px-4 py-2 rounded-lg"
                    >
                        Create Concern
                    </button>
                )}
            </div>


<div className="flex flex-wrap justify-between gap-4">
  {concerns.map((concern) => (
    <div
      key={concern.concern_id}
      className="border border-green-700 rounded-lg bg-white p-4 w-[calc(50%-0.5rem)]" // Ensures two containers per row
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          {concern.image_url ? (
            <img
              src={
                concern.image_url.startsWith("http")
                  ? concern.image_url
                  : `${api_url}${concern.image_url}`
              }
              alt={concern.name}
              className="w-20 h-20 rounded-md object-cover"
            />
          ) : (
            <p>No image</p>
          )}
          <h3 className="text-lg font-semibold">{concern.name}</h3>
        </div>

        <div className="flex gap-2">
          <button
            onClick={() => handleEditConcern(concern)}
            className="bg-blue-500 text-lg font-semibold text-white px-4 h-[40px] rounded-lg"
          >
            Edit
          </button>
          <button
            onClick={() => handleDeleteConcern(concern.concern_id)}
            className="bg-red-500 text-white text-lg font-semibold px-4 h-[40px] rounded-lg"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  ))}
</div>

        <DeletePrompt
            showModal={showDeleteModal}
            onDelete={handleConfirmDelete}
            onCancel={() => setShowDeleteModal(false)}
        />
        </div>
    );
}

export default ConcernManagement;
